module.exports = __webpack_public_path__ + "img/base_hiver_hiver.8a932cae.svg";